<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title='"元旦快乐-首页"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show='preloadingShow'></div>
    </transition>

    <Header
      v-if='true'
      :config='headerConfig'
      :isShowInfo='true' />

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

    <MySwiper :noSwiperClass='noSwiperClass' ref="mySwiper">
      <template v-slot:first-slide-content>
        <div class='home-page'>
          <div class="title">
            <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
              <img v-show="titleShow" src="../../../../assets/images/active/snail/new_years_day/title_img.png"/>
            </transition>
          </div>
          <div class="rule-btn monitor-btn" data-event="活动详情" @click="clickEvent()"></div>
          <div class="group-btn monitor-btn" data-event="加群" @click="clickEvent()"></div>
          <div class="egg-year monitor-btn" data-event="彩蛋" @click="clickEvent()"></div>
          <div class="act-btn monitor-btn" @click="nextPage()" data-event="参加活动">
            <a href="javascript:;"></a>
          </div>
          <div class="arrow-b monitor-btn" @click="nextPage()" data-event="参加活动"></div>
        </div>
      </template>
      <template v-slot:second-slide-content>
        <div class='content-page'>
          <div class='active-content'>
            <div class="decorate-box">
              <!-- 活动详情按钮 -->
              <a href="javascript:;" class="rule-btn monitor-btn" style="z-index: 10" data-event="活动详情" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/detail_btn.png"/>
              </a>
              <!-- 排行榜按钮 -->
              <a href="javascript:;" class="ranking-btn monitor-btn" style="z-index: 10" data-event="排行榜" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/ranking_btn.png"/>
              </a>
              <!-- 奖励按钮 -->
              <a href="javascript:;" class="award-list-btn monitor-btn" style="z-index: 10" data-event="奖励列表" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/award_list_btn.png"/>
              </a>
              <!-- 领奖按钮 -->
              <a href="javascript:;" class="award-btn monitor-btn" style="z-index: 10" data-event="领取奖励" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/award_btn.png"/>
              </a>

              <div class="practice monitor-btn" data-event="练习试玩" @click="clickEvent()"></div>
              <div class="total_score_board">
                <span class="goal">100</span>
              </div>

              <!-- 开始面板 -->
              <div class="score_board score_board_1">
                <img src="https://qcg.ink/HhoLr" alt="开始面板"/>
              </div>
              <!-- 九宫格 -->
              <div class="sudoku">
                <ul>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                </ul>
              </div>
            </div>

            <div class="cloud">
              <img src="../../../../assets/images/active/snail/new_years_day/cloud.png" alt="前云"/>
            </div>

            <!-- 操作按钮 -->
            <div class="operation-box">
              <div class="invite_btn monitor-btn" data-event="邀请好友" @click="onInvite()">
                <img src="../../../../assets/images/active/snail/new_years_day/invite_btn.png"/>
              </div>
              <div class="play_btn" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/play_btn.png" class="monitor-btn" data-event="开始游戏"/>
                <span>剩余次数：{{ activeInfo.times || 0}}</span>
              </div>
            </div>
            <!-- 分享相关DOM -->
            <div class="share-box" ref="imageDom">
              <img src="../../../../assets/images/active/snail/new_years_day/popup/help_share_img.png"/>
              <div class="share-img">
                <div class="url-box">
                  <p>{{ shareLink }}</p>
                </div>
                <div class="qrcode-box">
                  <div id="qrcode" class="qrcode"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:second-slide-content>
        <div class='content-page'>
          <div class='active-content'>
            <div class="decorate-box">
              <!-- 活动详情按钮 -->
              <a href="javascript:;" class="rule-btn monitor-btn" style="z-index: 10" data-event="活动详情" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/detail_btn.png"/>
              </a>
              <!-- 排行榜按钮 -->
              <a href="javascript:;" class="ranking-btn monitor-btn" style="z-index: 10" data-event="排行榜" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/ranking_btn.png"/>
              </a>
              <!-- 奖励按钮 -->
              <a href="javascript:;" class="award-list-btn monitor-btn" style="z-index: 10" data-event="奖励列表" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/award_list_btn.png"/>
              </a>
              <!-- 领奖按钮 -->
              <a href="javascript:;" class="award-btn monitor-btn" style="z-index: 10" data-event="领取奖励" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/award_btn.png"/>
              </a>

              <div class="practice monitor-btn" data-event="练习试玩" @click="clickEvent()"></div>
              <div class="total_score_board">
                <span class="goal">100</span>
              </div>

              <!-- 开始面板 -->
              <div class="score_board score_board_1">
                <img src="https://qcg.ink/HhoLr" alt="开始面板"/>
              </div>
              <!-- 九宫格 -->
              <div class="sudoku">
                <ul>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                  <li class="on"><div class="card"></div></li>
                </ul>
              </div>
            </div>

            <div class="cloud">
              <img src="../../../../assets/images/active/snail/new_years_day/cloud.png" alt="前云"/>
            </div>

            <!-- 操作按钮 -->
            <div class="operation-box">
              <div class="invite_btn monitor-btn" data-event="邀请好友" @click="onInvite()">
                <img src="../../../../assets/images/active/snail/new_years_day/invite_btn.png"/>
              </div>
              <div class="play_btn" @click="clickEvent()">
                <img src="../../../../assets/images/active/snail/new_years_day/play_btn.png" class="monitor-btn" data-event="开始游戏"/>
                <span>剩余次数：{{ activeInfo.times || 0}}</span>
              </div>
            </div>
            <!-- 分享相关DOM -->
            <div class="share-box" ref="imageDom">
              <img src="../../../../assets/images/active/snail/new_years_day/popup/help_share_img.png"/>
              <div class="share-img">
                <div class="url-box">
                  <p>{{ shareLink }}</p>
                </div>
                <div class="qrcode-box">
                  <div id="qrcode" class="qrcode"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </MySwiper>

    <!-- 弹窗 -->
    <!-- 分享弹窗 -->
    <div class="help-share-wrap popup_wrap" v-show="shareShow" >
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help-share-box popup_wrap-box" v-show="shareShow">
          <img :src="shareImg" alt="分享图片" />
          <button class="monitor-btn" @click="onCopy()" id="clipboard-btn" data-event="复制邀请链接"
            :data-clipboard-text="'双旦礼品大作战，兄弟们快来助力我获得手办！点击助力《最强蜗牛》活动：' + shareLink"></button>
          <div class="close-bg" v-show="shareShow" @click="closeShare()"></div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MySwiper from '@/components/MySwiper';
import { headerConfig } from '../../headerConfig';
import { onGetInitDataAPI } from '../api';
import { getRandomString, buriedLogger } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'newYearDay',
  components: {
    Header,
    Footer,
    Login,
    Os,
    MySwiper
  },

  data () {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'https://static.qcplay.com/snail/official/',
      preloadingShow: true,
      titleShow: true,
      noSwiperClass: '', // swiper-no-swiping
      shareLink: '',
      shareImg: null,
      shareShow: false,
      // 其他数据
      loginTypes: ['sms', 'channel'],
      aa: ''
    };
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    this.$nextTick(() => {
      this.mySwiper();
    });
    onGetInitDataAPI().then(response => {
      this.onInitDataCallback(response);
      this.preloadingShow = false;
    });

    // TODO:分享图测试
    this.$nextTick(() => {
      this.initShareData({ user_id: 10 });
    });

    // 埋点
    const bl = buriedLogger('snail', '蜗牛_双旦');
    this.setLogger(bl);
  },
  mounted () {},
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.user_id) {
          // TAG: 注销的时候
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          const { protocol, host } = window.location;
          this.shareLink = `${protocol}//${host}/snail/newYearDay/help${getRandomString()}`;
          this.initShareData(newValue);
        }
      }
    }
  },
  methods: {
    initShareData (info) {
      try {
        this.setShare({ link: this.shareLink });
        this.qrcode(`${this.helpUrl}?id=${info.user_id}`);
        this.$nextTick(() => {
          this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    qrcode (link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage () {
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 复制链接
    onCopy () {
      const clipboard = new Clipboard('#clipboard-btn');
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
      this.onCount('copy_link');
    },
    // swiper轮播
    mySwiper () {
      this.$refs.mySwiper.init();
    },
    // swiper 翻下一页
    nextPage () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      } else {
        this.$refs.mySwiper.nextSwiper(1);
      }
    },
    // 选择角色后
    selectCallback () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {},
    // TAG: 相关业务方法
    onInvite () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this.shareShow = true;
    },
    closeShare () {
      this.shareShow = false;
    },
    clickEvent () {
      this.onToast('敬请期待');
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'onCount',
      'setShare'
    ])

  }
};
</script>

<style lang='less'>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/snail/newYearDay/index/index.vue